// extracted by mini-css-extract-plugin
export default {"link":"reN0ssqQge9Y7wO_r6EB","body":"vuvHskGoFEYz8ECcP3r1"};